import { Skeleton } from "@mui/material";
import styles from "./list.module.css";

/**
 * Skeleton loader for the User Role List page. Mirrors the real layout
 * (filter bar, table on desktop, stacked cards on mobile) so nothing
 * jumps around once the data arrives.
 */
const UserRoleListLoader = ({ rows = 6 }) => {
    const rowArray = Array.from({ length: rows });

    return (<div aria-busy="true" aria-label="Loading user roles">
        <div className={`${styles.TableFilterHead}`}>
            <Skeleton variant="rounded" width="100%" height={42} style={{ maxWidth: 340, flex: "1 1 260px" }} />
            <Skeleton variant="rounded" width={100} height={42} style={{ borderRadius: 8 }} />
        </div>

        {/* Desktop table skeleton */}
        <div className={`${styles.CusTable}`}>
            <div style={{ background: "#fff", borderRadius: 10, boxShadow: "0 0 20px 0 rgba(76,87,125,0.06)", padding: "18px 20px" }}>
                <div style={{ display: "flex", gap: 24, marginBottom: 18 }}>
                    {["Name", "Active", ""].map((_, i) => (
                        <Skeleton key={i} variant="text" width={i === 2 ? 70 : 140} height={18} style={{ flex: 1 }} />
                    ))}
                </div>
                {rowArray.map((_, rowIdx) => (
                    <div key={rowIdx} style={{ display: "flex", alignItems: "center", gap: 24, padding: "14px 0", borderTop: "1px solid #f2f2f6" }}>
                        <Skeleton variant="text" width={180} style={{ flex: 1 }} />
                        <Skeleton variant="rounded" width={38} height={22} style={{ flex: 1, borderRadius: 20 }} />
                        <div style={{ display: "flex", gap: 6, flex: 1, justifyContent: "flex-end" }}>
                            <Skeleton variant="rounded" width={34} height={34} style={{ borderRadius: 8 }} />
                            <Skeleton variant="rounded" width={34} height={34} style={{ borderRadius: 8 }} />
                        </div>
                    </div>
                ))}
            </div>
        </div>

        {/* Mobile card skeleton */}
        <div className={`${styles.MobileCardList}`}>
            {rowArray.map((_, idx) => (
                <div key={idx} className={`${styles.CustomerCard}`}>
                    <div className={`${styles.CustomerCardHead}`}>
                        <Skeleton variant="text" width="55%" height={18} />
                        <Skeleton variant="rounded" width={34} height={20} style={{ borderRadius: 20 }} />
                    </div>
                    <div className={`${styles.CustomerCardActions}`}>
                        <Skeleton variant="rounded" width={34} height={34} style={{ borderRadius: 8 }} />
                        <Skeleton variant="rounded" width={34} height={34} style={{ borderRadius: 8 }} />
                    </div>
                </div>
            ))}
        </div>
    </div>);
};

export default UserRoleListLoader;